import React from 'react';
import { ChevronRight } from '../Icons/Icons';

const CrmBreadcrumb = ({ href, icon, ariaLabel, label }) => (
  <div className="cdp-breadcrumb">
    <a
      href={href}
      className="cdp-breadcrumb-icon"
      aria-label={ariaLabel}
      style={{ textDecoration: 'none' }}
    >
      {icon}
    </a>
    <span className="cdp-breadcrumb-separator" aria-hidden="true">
      <ChevronRight />
    </span>
    <span className="cdp-breadcrumb-label">{label}</span>
  </div>
);

export default CrmBreadcrumb;
